import { render, staticRenderFns } from "./addsubRecordTable.vue?vue&type=template&id=29ae6899&scoped=true&"
import script from "./addsubRecordTable.vue?vue&type=script&lang=js&"
export * from "./addsubRecordTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29ae6899",
  null
  
)

export default component.exports